import React from "react";
import { useLanguage } from "@/context/LanguageContext";

/**
 * Visual rating scale (1-5) for goalkeeper glove attributes.
 * Renders labelled rows with 5 small markers each (filled green / empty white/15).
 *
 * Props:
 *  - ratings: { grip, wet, dry, cushioning, durability } each 1..5
 *  - compact: boolean — smaller spacing for product cards
 *  - testIdPrefix: string for data-testid scoping
 */
const ORDER = ["wet", "dry", "cushioning", "durability"];

const Marker = ({ filled }) => (
  <span
    aria-hidden
    className={`inline-block w-2.5 h-2.5 ${
      filled ? "bg-[#00A651]" : "bg-white/15"
    }`}
  />
);

const RatingScale = ({ ratings, compact = false, testIdPrefix = "rating" }) => {
  const { t } = useLanguage();
  if (!ratings) return null;

  return (
    <div
      data-testid={`${testIdPrefix}-scale`}
      className={`grid ${compact ? "gap-1.5" : "gap-2"}`}
    >
      {ORDER.map((key) => {
        const value = Math.max(0, Math.min(5, ratings[key] ?? 0));
        return (
          <div
            key={key}
            data-testid={`${testIdPrefix}-row-${key}`}
            className="flex items-center justify-between gap-3"
          >
            <span
              className={`font-condensed uppercase tracking-widest ${
                compact ? "text-[10px]" : "text-xs"
              } text-white/55`}
            >
              {t.rating_labels[key]}
            </span>
            <div className="flex gap-1">
              {[0, 1, 2, 3, 4].map((i) => (
                <Marker key={i} filled={i < value} />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RatingScale;
